import * as React from "react";
import { computed, makeObservable } from "mobx";
import { createUuid, type UUID } from "../../utils/uuid";
import { type PreOpsChecklist } from "../../api";
import { observer } from "mobx-react";
import type { PaginationState } from "../../utils/pagination-state";
import {
    type PreOpsChecklistQuery,
    type PreOpsChecklistsApiResource,
} from "../../domain/repositories/repository-pre-ops-checklists";
import { type ElofleetListProps } from "../atoms/elofleet-list";
import { SectionPreOpsChecklistSettings } from "./section-pre-ops-checklist-settings";
import css from "./list-checklists.scss";
import { LayoutList } from "../layouts/layout-list";
import { defaultPageSize } from "../../utils/constants";

export interface ListPreOpsChecklistsProps extends Omit<ElofleetListProps, "items" | "columns"> {
    readonly ids?: UUID[];
    readonly commandBar?: JSX.Element;
    readonly canDelete?: boolean;
    readonly canUpdate?: boolean;
}

import { store } from "../../store";

@observer
export class ListPreOpsChecklists extends React.Component<ListPreOpsChecklistsProps> {
    private _listStateId = createUuid();

    constructor(props: ListPreOpsChecklistsProps) {
        super(props);
        makeObservable(this);
    }

    componentDidMount(): void {
        store.serviceListStates.preOpsChecklists.initializeList(this._listStateId, {
            query: () => this.query,
        });
    }

    @computed private get paginationState(): PaginationState<PreOpsChecklistsApiResource> {
        return store.serviceListStates.preOpsChecklists.getPaginationState(this._listStateId);
    }

    @computed private get query(): PreOpsChecklistQuery {
        return { pageSize: defaultPageSize };
    }

    @computed private get preOpsChecklists(): PreOpsChecklist[] {
        if (this.props.ids) {
            return this.props.ids
                .map((id) => store.repositoryPreOpsChecklists.byId(id))
                .filter((checklist) => Boolean(checklist)) as PreOpsChecklist[];
        }
        return store.repositoryPreOpsChecklists.byQuery(
            this.query,
            this.paginationState.pagination,
        );
    }

    public render(): JSX.Element {
        if (!store.serviceListStates.preOpsChecklists.isInitialized(this._listStateId)) {
            return <></>;
        }
        return (
            <LayoutList
                paginationState={this.paginationState}
                commandBar={this.props.commandBar ? this.props.commandBar : undefined}
                title={store.i18n.t("listPreOpsChecklist.title")}
            >
                <div className="flex-col gap-2 px-2 pt-2">
                    {this.preOpsChecklists.map(({ id }) => (
                        <SectionPreOpsChecklistSettings
                            className={css.listChecklists__checklist}
                            id={id}
                            key={id}
                            canDelete={this.props.canDelete}
                            canUpdate={this.props.canUpdate}
                        />
                    ))}
                </div>
            </LayoutList>
        );
    }
}
